export const formatTime = (timestamp) => {
  if (!timestamp) return "-";
  return timestamp.split("T")[1]?.substring(0, 5) || "-";
};

export const toMinutes = (t) => {
  if (!t || t === "-") return NaN;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const formatDuration = (mins) => {
  if (isNaN(mins) || mins <= 0) return "0m";
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

export const formatWorkedHours = (mins) => {
  if (!mins || mins <= 0) return "-";
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

/**
 * Combines attendance data for one day.
 */
export const combineAttendance = (date, employees, logs, rosters) => {
  if (!date || employees.length === 0) return [];

  const dayRoster = rosters[date] || {};
  const nextDay = new Date(new Date(date).setDate(new Date(date).getDate() + 1))
    .toISOString()
    .split("T")[0];

  return employees.map((emp) => {
    let shiftStart = emp.shift_start_time
      ? emp.shift_start_time.substring(0, 5)
      : "09:00";
    let shiftEnd = emp.shift_end_time
      ? emp.shift_end_time.substring(0, 5)
      : "17:00";

    for (const key in dayRoster) {
      const empFound = dayRoster[key].employees?.find(
        (e) => e.employee_code === emp.employee_code
      );
      if (empFound) {
        shiftStart = empFound.start_time?.substring(0, 5) || shiftStart;
        shiftEnd = empFound.end_time?.substring(0, 5) || shiftEnd;
        break;
      }
    }

    const shiftStartH = parseInt(shiftStart.split(":")[0]);
    const shiftEndH = parseInt(shiftEnd.split(":")[0]);
    const isNightShift = shiftEndH < shiftStartH;

    const empLogs = logs
      .filter((log) => {
        if (log.employee_code !== emp.employee_code) return false;
        const punchDate = log.punch_at.split("T")[0];
        const punchTime = log.punch_at.split("T")[1]?.substring(0, 5);
        if (punchDate === date) return true;
        if (
          isNightShift &&
          punchDate === nextDay &&
          parseInt(punchTime.split(":")[0]) < 10
        )
          return true;
        return false;
      })
      .sort((a, b) => a.punch_at.localeCompare(b.punch_at));

    let entry = "-";
    let exit = "-";

    if (empLogs.length > 0) {
      if (isNightShift) {
        const entryPunch = empLogs.find((l) => {
          const [logDate, logTime] = l.punch_at.split("T");
          const hour = parseInt(logTime.substring(0, 2));
          return logDate === date && hour >= shiftStartH;
        });
        const exitPunch = empLogs.find((l) => {
          const [logDate, logTime] = l.punch_at.split("T");
          const hour = parseInt(logTime.substring(0, 2));
          return logDate === nextDay && hour <= shiftEndH + 2;
        });

        entry = entryPunch ? formatTime(entryPunch.punch_at) : "-";
        exit = exitPunch ? formatTime(exitPunch.punch_at) : "-";
      } else {
        entry = formatTime(empLogs[0]?.punch_at);
        exit = formatTime(empLogs[empLogs.length - 1]?.punch_at);
      }
    }

    // let status = "Absent";
    // if (entry !== "-") {
    //   const diff = toMinutes(entry) - toMinutes(shiftStart);
    //   if (diff > 0) status = `Late by ${formatDuration(diff)}`;
    //   else if (diff < 0)
    //     status = `Early by ${formatDuration(Math.abs(diff))}`;
    //   else status = "On Time";
    // }
    let status = "Absent";
    if (entry !== "-" && exit !== "-") {
      const shiftStartMins = toMinutes(shiftStart);
      const shiftEndMins = toMinutes(shiftEnd);
      const entryMins = toMinutes(entry);
      const exitMins = toMinutes(exit);

      let entryDiff = entryMins - shiftStartMins;
      let exitDiff = shiftEndMins - exitMins; // how much before shift end they left

      if (entryDiff > 0 && exitDiff > 0) {
        status = `Late By ${formatDuration(
          entryDiff
        )}& Left Early ${formatDuration(exitDiff)}`;
      } else if (entryDiff > 0) {
        status = `Late by ${formatDuration(entryDiff)}`;
      } else if (exitDiff > 0) {
        status = `Left Early by ${formatDuration(exitDiff)}`;
      } else {
        status = "On Time";
      }
    } else if (entry !== "-" && exit === "-") {
      status = "No Exit";
    } else if (entry === "-" && exit !== "-") {
      status = "No Entry";
    }

    let workedHours = "-";
    if (entry !== "-" && exit !== "-") {
      let diff = toMinutes(exit) - toMinutes(entry);
      if (diff < 0) diff += 24 * 60;
      workedHours = formatWorkedHours(diff);
    }

    let lateBy = null;
let earlyBy = null;

    return {
      date,
      employee_code: emp.employee_code,
      name: emp.name || emp.first_name,
      department: emp.department || "-",
      designation: emp.designation || "-",
      shiftStart,
      shiftEnd,
      entry,
      exit,
      workedHours,
      status,
      lateBy, // ← add this
      earlyBy,
    };
  });
};
